// Customizable Area Start
import React, { Component } from "react";

interface Props {
  isVisible: boolean;
  children: React.ReactNode;
}

class ConditionalRenderer extends Component<Props> {
  render() {
    const { isVisible, children } = this.props;
    return isVisible ? <>{children}</> : null;
  }
}

export default ConditionalRenderer;
// Customizable Area End
